import React, { useMemo, useReducer, useState } from "react";
import styles from "../../_components/Styles/BaseStyleForAdminPanel.module.css";
import { InputText } from "../../_components/InputText/InputText";
import { Button } from "@mui/material";
import {RightCreate} from "../../../../types/api/authorization/right.types";
import {useFetchAllFullInfoUser} from "../../../../hooks/authorization/useFetchAllFullInfoUser";
import {useFetchAllPositions} from "../../../../hooks/authorization/useFetchAllPositions";
import {getFullName} from "../../../../utils/nameFormatter";
import {rightService} from "../../../../services/authorization/right-service";
import useAppSnackbar from "../../../../hooks/useAppSnackbar";
import OpenCheckboxList from "../../_components/OpenCheckboxList/OpenCheckboxList";


export const CreateRight = () => {
    const {showSuccess, showError, SnackbarComponent} = useAppSnackbar();
    const InitialState: RightCreate = {
        name: "",
        tag: "",
        comment: "",
        positionIds: [],
        userIds: [],
    };

    const {
        data: usersData
    } = useFetchAllFullInfoUser();

    const {
        data: positionsData
    } = useFetchAllPositions();

    const reducer = (state: RightCreate, action: any) => {
        switch (action.type) {
            case "SET_FIELD":
                return { ...state, [action.name]: action.value };
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(reducer, InitialState);

    const handleValue = (event: any) => {
        dispatch({ type: "SET_FIELD", name: event.target.name, value: event.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await rightService.create(state);
            showSuccess("Права сохранены")
        }catch (e) {
            showError("Ошибка при создании прав")
        }
    };


    const [posSearch, setPosSearch] = useState<string>("");
    const [userSearch, setUserSearch] = useState<string>("");

    const filteredPositions = useMemo(() => {
        const q = posSearch.trim().toLowerCase();
        if (!q) return positionsData ?? [];
        return (positionsData ?? []).filter(p => (p.title ?? "").toLowerCase().includes(q));
    }, [posSearch, positionsData]);

    const filteredUsers = useMemo(() => {
        const q = userSearch.trim().toLowerCase();
        if (!q) return usersData ?? [];
        return (usersData ?? []).filter(u => getFullName(u).toLowerCase().includes(q));
    }, [userSearch, usersData]);

    return (
        <form className={styles.formWrapper} onSubmit={handleSubmit}>
            <div className={styles.formCard}>
                <div className={styles.formHeader}>
                    <h2 className={styles.formTitle}>Создание прав</h2>
                    <p className={styles.formSubtitle}>Заполните информацию</p>
                </div>

                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h3 className={styles.sectionTitle}>Основная информация</h3>
                    </div>
                    <div className={styles.inputsGrid}>
                        <InputText
                            name="name"
                            value={state.name}
                            handleValue={handleValue}
                            label="Название"
                            idField="name"
                            required
                        />
                        <InputText
                            name="tag"
                            value={state.tag}
                            handleValue={handleValue}
                            label="Тэг"
                            idField="tag"
                            required
                        />
                    </div>
                    <hr className={styles.sectionDivider} />
                </div>

                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h3 className={styles.sectionTitle}>Описание</h3>
                    </div>
                    <div className={styles.inputsGrid}>
                        <div className={styles.fullRow}>
                            <InputText
                                name="comment"
                                value={state.comment}
                                handleValue={handleValue}
                                label="Комментарий"
                                idField="comment"
                                required
                                multiline
                                minRows={4}
                            />
                        </div>
                    </div>
                    <hr className={styles.sectionDivider} />
                </div>

                <div className={styles.section}>

                    <div className={styles.inputsGrid}>
                        <OpenCheckboxList
                            label="Должности"
                            name="positionIds"
                            options={(filteredPositions ?? []).map(p => ({ value: p.id, label: p.title }))}
                            selected={state.positionIds as string[]}
                            onChange={handleValue}
                            searchValue={posSearch}
                            onSearchChange={setPosSearch}
                        />

                        <OpenCheckboxList
                            label="Сотрудники"
                            name="userIds"
                            options={(filteredUsers ?? []).map(u => ({ value: u.id, label: getFullName(u) }))}
                            selected={state.userIds as string[]}
                            onChange={handleValue}
                            searchValue={userSearch}
                            onSearchChange={setUserSearch}
                        />
                    </div>
                </div>

                <div className={styles.btn}>
                    <Button
                        type="submit"
                        className={`${styles.buttonBase} ${styles.buttonPrimary}`}
                    >
                        Создать
                    </Button>
                </div>
            </div>

            <SnackbarComponent />
        </form>
    );
};

export default CreateRight;
